module.exports = __webpack_public_path__ + "static/media/15.0da5d857.jpg";